"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextField_1 = __importDefault(require("../../../TextField"));
var form_1 = require("../../context/form");
var props_1 = require("../../context/props");
var CommentField = function () {
    var _a = (0, form_1.useFormContext)(), comment = _a.comment, onChangeComment = _a.onChangeComment, errors = _a.errors;
    var _b = (0, props_1.usePropsContext)(), translate = _b.translate, isLoading = _b.isLoading;
    return (react_1.default.createElement(TextField_1.default, { label: translate('feedbackModal.review'), value: comment, onChange: onChangeComment, name: "comment", fullWidth: true, multiline: true, rows: "4", required: true, variant: "outlined", disabled: isLoading, error: !!errors.comment, helperText: errors.comment, inputProps: {
            maxLength: 1000
        } }));
};
exports.default = CommentField;
